import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const Profile = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg width={width} height={height} style={style} viewBox="0 0 24 24">
      <g transform="matrix(1,0,0,1,-4,-4)">
        <path d="M16,4C22.627,4 28,9.373 28,16C28,22.627 22.627,28 16,28C9.373,28 4,22.627 4,16C4,9.373 9.373,4 16,4ZM11.51,25.16C12.864,25.826 14.389,26.2 16,26.2C17.632,26.2 19.174,25.817 20.542,25.136C20.129,21.81 18.642,20.267 15.984,20.22C13.364,20.174 11.908,21.676 11.522,25.045L11.51,25.161L11.51,25.16ZM16,5.8C10.367,5.8 5.8,10.367 5.8,16C5.8,19.319 7.385,22.267 9.84,24.13C10.481,20.397 12.526,18.406 15.897,18.419L16.016,18.42C19.416,18.48 21.502,20.454 22.198,24.101C24.63,22.237 26.2,19.302 26.2,16C26.2,10.367 21.633,5.8 16,5.8ZM16,7.9C18.651,7.9 20.8,10.049 20.8,12.7C20.8,15.351 18.651,17.5 16,17.5C13.349,17.5 11.2,15.351 11.2,12.7C11.2,10.049 13.349,7.9 16,7.9ZM16,9.7C14.343,9.7 13,11.043 13,12.7C13,14.357 14.343,15.7 16,15.7C17.657,15.7 19,14.357 19,12.7C19,11.043 17.657,9.7 16,9.7Z" />
      </g>
    </svg>
  );
};

Profile.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Profile;
